import { PlaceholderKind } from '@woundtech/ui-constants';
import { HOME_HEALTH_V2_FLAG } from 'common/constants';
import { useLDFlagValue } from 'common/useLDFlagValue';
import { fullAddressFormat } from 'fhir/general/Address';
import { identifierBySystem } from 'fhir/general/Identifier/formatters';
import HomeHealthCard from 'master-list/common/Card/Card';
import { NPI_SYSTEM } from 'master-list/constants';
import React, { useMemo } from 'react';
import { phoneNumber } from 'styleguide/form/Telecom/formatters';

type Props = {
  data: any;
  onClick: () => void;
};

const Component: React.FC<Props> = ({ data, onClick }) => {
  const isHomeHealthV2FlagEnabled = useLDFlagValue(
    HOME_HEALTH_V2_FLAG
  );

  const npiData = isHomeHealthV2FlagEnabled ? [{
    icon: '',
    name: 'NPI',
    value: identifierBySystem(
      data?.identifier,
      NPI_SYSTEM
    ),
    columns: 1,
  }] : []

  const attributes = useMemo(() => {
    const telecom = data?.telecom?.find((item) => item?.system === 'phone');
    const telecomValue = telecom
      ? phoneNumber(telecom)
      : PlaceholderKind.NotAvailable;
    return [
      ...npiData,
      {
        icon: 'phone',
        value: telecomValue,
        columns: 2,
      },
      {
        icon: 'location_on',
        value: fullAddressFormat(data?.address?.[0]),
        columns: 2,
      },
    ];
  }, [data]);

  return (
    <HomeHealthCard
      title={data?.name?.[0]?.text}
      onClick={onClick}
      data={data}
      customAttributes={attributes}
      cardStatus={data?.active}
    />
  );
};

export default React.memo(Component);
